import { lazy, Suspense, ComponentType } from 'react';
import ErrorBoundary from './ErrorBoundary';

interface LazyRouteProps {
  loader: () => Promise<{ default: ComponentType<any> }>;
  fallback: React.ReactNode;
  children?: never; // Prevent children prop
}

/**
 * A wrapper component that handles lazy loading with proper error boundaries.
 * This ensures that chunk loading errors are caught and displayed with our custom UI.
 */
const LazyRoute = ({ loader, fallback }: LazyRouteProps) => {
  const LazyComponent = lazy(loader);

  return (
    <ErrorBoundary>
      <Suspense fallback={fallback}>
        <LazyComponent />
      </Suspense>
    </ErrorBoundary>
  );
};

export default LazyRoute;